import React from 'react';
import PropTypes from 'prop-types';

import Popover from 'src/core/gd-components/gd-popover/popover';
import EstimateSelector from "./estimate-selector";
import EstimateInputs from "./estimate-inputs";
import EstimateSummaryItem from "./estimate-summary-item";

export default class EstimatePickerPopover extends React.Component {

    static propTypes = {
        hours: PropTypes.number,
        minutes: PropTypes.number,
        childrenValue: PropTypes.number,

        maxValue: PropTypes.number, // minutes

        attachment: PropTypes.string,
        targetAttachment: PropTypes.string,
        offset: PropTypes.string,

        showDaysSelector: PropTypes.bool,

        getTargetFunc: PropTypes.func,
        onClickOutside: PropTypes.func,
        onSave: PropTypes.func,
    }
    static defaultProps = {
        showDaysSelector: true
    }

    state = {
        hours: this.props.hours,
        minutes: this.props.minutes
    }

    constructor(props) {
        super(props);

        this.minutesSelectorItems = [];
        this.minutesSelectorItems.push({value:15, label:"15"});
        this.minutesSelectorItems.push({value:30, label:"30"});
        this.minutesSelectorItems.push({value:45, label:"45"});

        this.hoursSelectorItems = [];
        this.hoursSelectorItems.push({value:60, label:"1"});
        //this.hoursSelectorItems.push({value:90, label:"1½"});
        this.hoursSelectorItems.push({value:120, label:"2"});
        this.hoursSelectorItems.push({value:180, label:"3"});
        this.hoursSelectorItems.push({value:240, label:"4"});
        this.hoursSelectorItems.push({value:300, label:"5"});
        this.hoursSelectorItems.push({value:360, label:"6"});
        this.hoursSelectorItems.push({value:420, label:"7"});

        this.daysSelectorItems = [];
        this.daysSelectorItems.push({value:480, label:"1"});
        this.daysSelectorItems.push({value:960, label:"2"});
        this.daysSelectorItems.push({value:1440, label:"3"});
        this.daysSelectorItems.push({value:1920, label:"4"});
    }

    _getValue = () => {
        const hours     = this.state.hours || 0
        const minutes   = this.state.minutes || 0
        return hours * 60 + minutes
    }

    onHoursChange = (value) => {
        let hours = value > 10000 ? 10000 : value;

        const minutes   = this.state.minutes || 0
        const newValue  = hours * 60 + minutes
        if (this.props.maxValue && newValue > this.props.maxValue) {
            this.setState({
                hours   : 23,
                minutes : 59
            });
        } else {
            this.setState({
                hours: hours
            });
        }
    }

    onMinutesChange = (value) => {
        let minutes = value > 59 ? 59 : value;

        const hours     = this.state.hours || 0
        const newValue  = hours * 60 + minutes
        if (this.props.maxValue && newValue > this.props.maxValue) {
            this.setState({
                hours   : 23,
                minutes : 59
            });
        } else {
            this.setState({
                minutes: minutes
            });
        }
    }

    onSave = () => {
        this.props.onSave(this._getValue());
    }

    render() {
        const estimate = this._getValue();

        const menuClasses = Classes("ui5-popover-selector", "estimate-selector", {
            "with-summary": !!this.props.childrenValue
        })

        return (
            <Popover className="gd-estimate-popover"
                     targetClass={this.props.getTargetFunc ? null : "pop-target"}
                     getTargetFunc={this.props.getTargetFunc}
                     attachment={this.props.attachment}
                     targetAttachment={this.props.targetAttachment}
                     constraints={[{
                         to: "window",
                         attachment: "together",
                         pin: true
                     }]}
                     offset={this.props.offset}
                     onClickOutside={this.props.onClickOutside}>

                <div className={menuClasses}>
                    <EstimateSelector label="Minutes"   items={this.minutesSelectorItems}    estimate={estimate} onSelectorItemClick={this.props.onSave}/>
                    <EstimateSelector label="Hours"     items={this.hoursSelectorItems}      estimate={estimate} onSelectorItemClick={this.props.onSave}/>
                    {this.props.showDaysSelector &&
                        <EstimateSelector label="Days"      items={this.daysSelectorItems}       estimate={estimate} onSelectorItemClick={this.props.onSave}/>}

                    <EstimateInputs hours={this.state.hours}
                                    minutes={this.state.minutes}
                                    onHoursChange={this.onHoursChange}
                                    onMinutesChange={this.onMinutesChange}
                                    onSave={this.onSave}/>

                    {!!this.props.childrenValue &&
                    <div className="summary form-summary">
                        <EstimateSummaryItem title="Parent task" value={estimate ? gd.utils.minutesToHMStr(estimate) : '0m.'}/>
                        <EstimateSummaryItem title="Subtasks" value={gd.utils.minutesToHMStr(this.props.childrenValue)}/>
                        <EstimateSummaryItem title="Total" value={gd.utils.minutesToHMStr(estimate + this.props.childrenValue)}/>
                    </div>}
                </div>
            </Popover>
        );
    }
}
